import { Text as RNText, type TextProps as RNTextProps } from "react-native";

import { palette, type } from "@/design/tokens";

type Variant = keyof typeof type;

type TextProps = RNTextProps & {
  variant?: Variant;
  color?: string;
};

export function Text({ variant = "body", color = palette.text, style, ...rest }: TextProps) {
  return <RNText {...rest} style={[type[variant], { color }, style]} />;
}

export function Overline(props: Omit<TextProps, "variant">) {
  return <Text variant="overline" color={palette.muted} {...props} />;
}

export function Muted(props: TextProps) {
  return <Text color={palette.muted} {...props} />;
}
